import {  Container, LinearProgress, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles({
    container: {
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "20px",
        paddingTop: "50px"
    },
    root: {
        width: '100%',
    }
})

export default function Loading() {
    let classes = useStyles();
    return (
        <Container  fixed className={classes.container}>
            <Typography variant="h4">
                Loading . . .
            </Typography>
            <div className={classes.root}>
                <LinearProgress />
            </div>
        </Container>
    )
}